import { render, staticRenderFns } from "./jushuitan_shops.vue?vue&type=template&id=5e4fdb94"
import script from "./jushuitan_shops.vue?vue&type=script&lang=js"
export * from "./jushuitan_shops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports